import { TableFooter } from "@mui/material";
import styled from "styled-components";

export const TableFooterStyled = styled(TableFooter)`
  position: absolute;
  bottom: 0px;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors?.bg?.whiteBg};
  border-top: 1px solid rgba(224, 224, 224, 1);
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  display: flex !important;
  justify-content: end;
  td {
    width: 100% !important;
    border-bottom: none;
  }
  .MuiTableRow-root.MuiTableRow-footer {
    .MuiTableCell-root.MuiTableCell-footer {
      min-width: 100% !important;
    }
    .MuiBox-root {
      .MuiButtonBase-root.MuiIconButton-root {
        &:hover {
          cursor: pointer;
        }
        width: 36px;
        height: 36px;
        svg {
          width: 100% !important;
          height: 100% !important ;
          path {
            fill: "#000" !important ;
          }
        }
      }
    }
  }
`;
